import React from 'react';
import MainFilterPanels from '@client/components/search/MainFilterPanels';
import BasicFilters from '@client/feature/activeSubstance/components/Search/Filters/Basic';
import ExtraFilters from '@client/feature/activeSubstance/components/Search/Filters/ExtraFilters';
import { useFilterPanels } from '@client/hooks/useFilterPanels';
import { BASIC_FILTER_KEYS, EXTRA_FILTER_KEYS } from '@client/feature/activeSubstance/config/filterConfigs';
import CollapseIcon from '@client/components/ui/CollapseIcon';
import SearchIcon from '../../../../img/search-icon.svg';
import AddFiltersIcon from '../../../../img/add_filters.svg';

const FilterPanels = ({ filters, onFilterChange }) => {
  const { basicCount, extraCount, defaultActiveKeys } = useFilterPanels(
    filters,
    BASIC_FILTER_KEYS,
    EXTRA_FILTER_KEYS
  );

  const expandIcon = ({ isActive }) => (
    <CollapseIcon
      isActive={isActive}
      style={{
        width: '24px',
        height: '24px',
        transition: 'transform 0.3s ease',
        transform: isActive ? 'rotate(0deg)' : 'rotate(180deg)',
      }}
    />
  );

  return (
    <MainFilterPanels
      BasicFiltersComponent={BasicFilters}
      ExtraFiltersComponent={ExtraFilters}
      filters={filters}
      onFilterChange={onFilterChange}
      basicCount={basicCount}
      extraCount={extraCount}
      defaultActiveKeys={defaultActiveKeys}
      expandIcon={expandIcon}
      icons={{ search: SearchIcon, addFilters: AddFiltersIcon }}
    />
  );
};

export default React.memo(FilterPanels);